import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  template: require("./template.html")
})
class LabelDotDotTooltip extends Vue {
  @Prop({ default: "" })
  text: string;

  @Prop({ default: 0 })
  length: number;
  
  @Prop({ default: true })
  showTooltip: boolean;

  @Prop({default:()=>'right'})
  placement: string;
  
  get cutedOutText() {
    if (this.text && this.text.length > this.length) {
      return this.text.substring(0, this.length) + "...";
    } else {
      return this.text;
    }
  }
}
export default LabelDotDotTooltip;
